export { default as store } from './Store'
export {
  FooterContentAction,
  FooterContentGetter
} from './modules/footer.store'
export {
  accessorFactory,
  storeFactory
} from './content-page.store'
import { ContentPageStore as _ContentPageStore } from './content-page.store'
export type ContentPageStore<T> = _ContentPageStore<T>
export { Namespace } from './Namespaces'
